import { useCallback, useState } from 'react';

var useSwitchState = function useSwitchState() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(defaultValue),
      isTrue = _useState[0],
      setIsTrue = _useState[1];

  var onSwitchToTrue = useCallback(function () {
    return setIsTrue(true);
  }, []);
  var onSwitchToFalse = useCallback(function () {
    return setIsTrue(false);
  }, []);
  var onToggleState = useCallback(function () {
    return setIsTrue(function (prevState) {
      return !prevState;
    });
  }, []);
  return [isTrue, onSwitchToTrue, onSwitchToFalse, onToggleState, setIsTrue];
};

export default useSwitchState;